import { visit } from 'graphql';
import flatten from 'lodash/flatten';
function _isNodeWithDirectives(node) {
    return node != null && node.directives != null;
}
export function getDirectiveType(directiveNode) {
    var _a, _b, _c, _d;
    const typeName = (_d = (_c = (_b = (_a = directiveNode) === null || _a === void 0 ? void 0 : _a.arguments) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 : _d.value;
    if (typeName == null) {
        throw new Error('Invalid @computed directive found. No type specified');
    }
    return typeName;
}
export function nodeHasComputedDirectives(node) {
    if (!_isNodeWithDirectives(node)) {
        return false;
    }
    return node.directives != null && node.directives.some((d) => d.name.value === 'computed');
}
export function replaceDirectivesByFragments(query, entities) {
    if (query == null) {
        return null;
    }
    const replaceDirectiveByFragment = (node) => {
        var _a, _b;
        const computedDirective = (_a = node.directives) === null || _a === void 0 ? void 0 : _a.find((d) => d.name.value === 'computed');
        const directiveType = getDirectiveType(computedDirective);
        const entityType = entities[directiveType];
        if (entityType == null) {
            throw new Error(`No entity found for type "${directiveType}"`);
        }
        const fieldName = node.name.value;
        const entityField = entityType.fields[fieldName];
        if (entityField == null) {
            throw new Error(`No resolver found for @computed directive "${fieldName}" in type "${directiveType}"`);
        }
        return replaceDirectivesByFragments((_b = entityField.dependencies) === null || _b === void 0 ? void 0 : _b.definitions[0], entities);
    };
    return visit(query, {
        Field(node) {
            if (!nodeHasComputedDirectives(node)) {
                return undefined;
            }
            return replaceDirectiveByFragment(node);
        },
        Directive(node) {
            if (node.name.value === 'computed') {
                return null;
            }
        },
    });
}
export function addFragmentsFromDirectives(query, entities) {
    if (query == null) {
        return null;
    }
    const addFragmentToNode = (node) => {
        var _a, _b;
        const computedDirective = (_a = node.directives) === null || _a === void 0 ? void 0 : _a.find((d) => d.name.value === 'computed');
        const directiveType = getDirectiveType(computedDirective);
        const entityType = entities[directiveType];
        if (entityType == null) {
            throw new Error(`No entity found for type "${directiveType}"`);
        }
        const fieldName = node.name.value;
        const entityField = entityType.fields[fieldName];
        if (entityField == null) {
            throw new Error(`No resolver found for @computed directive "${fieldName}" in type "${directiveType}"`);
        }
        return addFragmentsFromDirectives((_b = entityField.dependencies) === null || _b === void 0 ? void 0 : _b.definitions[0], entities);
    };
    const firstPass = visit(query, {
        Field(node) {
            if (!nodeHasComputedDirectives(node)) {
                return undefined;
            }
            return [node, addFragmentToNode(node)];
        },
    });
    return visit(firstPass, {
        SelectionSet(node) {
            node.selections = flatten(node.selections);
            return node;
        },
    });
}
//# sourceMappingURL=directive-utils.js.map